import React from "react";
import { useIntl } from "react-intl";
import { PeriodicalCheckSettingsLink } from "./PeriodicalCheckSettingsLink";
import css from "./IssueNumberingHint.module.css";
export var IssueNumberingHint = function (_a) {
    var settings = _a.settings;
    var formatMessage = useIntl().formatMessage;
    var continuousNumbering = settings.continuousNumbering, continuousNumberingAnchorVolumeLabel = settings.continuousNumberingAnchorVolumeLabel, continuousNumberingStartNumber = settings.continuousNumberingStartNumber;
    var mode;
    if (continuousNumbering &&
        continuousNumberingAnchorVolumeLabel &&
        continuousNumberingStartNumber !== null) {
        mode = formatMessage({ id: "ui-br-legaldeposits.periodicals.numbering.hint.continuousFrom" }, {
            volume: continuousNumberingAnchorVolumeLabel,
            number: continuousNumberingStartNumber,
        });
    }
    else {
        mode = formatMessage({
            id: continuousNumbering
                ? "ui-br-legaldeposits.periodicals.numbering.hint.continuous"
                : "ui-br-legaldeposits.periodicals.numbering.hint.perYear",
        });
    }
    return (React.createElement("div", { className: css.hint, "data-testid": "issue-numbering-hint" },
        "(",
        mode,
        ",",
        " ",
        React.createElement(PeriodicalCheckSettingsLink, { settings: settings, label: formatMessage({
                id: "ui-br-legaldeposits.periodicals.numbering.change",
            }) }),
        ")"));
};
